module.exports = __webpack_public_path__ + "static/media/1 03 meteorolog.1168795b.mp3";